import { Tab, Tabs } from '@material-ui/core';
import React, { FC, memo, useCallback } from 'react';

interface Props {
  tabs: { label: string; disabled: boolean | undefined }[];
  index: number;
  indexChange: (idx: number) => void;
  variant?: 'scrollable' | 'fullWidth' | 'standard';
  indicatorColor?: 'secondary' | 'primary';
  textColor?: 'secondary' | 'primary' | 'inherit';
  disableRipple?: boolean;
  disableFocusRipple?: boolean;
}

export const MuiTabs: FC<Props> = memo(
  ({
    tabs,
    index,
    indexChange,
    variant,
    indicatorColor,
    textColor,
    disableRipple,
    disableFocusRipple
  }: Readonly<Props>) => {
    const onChange = useCallback(
      (_, v: number) => {
        indexChange(v);
      },
      [indexChange]
    );

    return (
      <Tabs
        value={index}
        onChange={onChange}
        indicatorColor={indicatorColor}
        textColor={textColor}
        variant={variant}
      >
        {tabs.map((tab, idx) => (
          <Tab
            disableRipple={disableRipple}
            disableFocusRipple={disableFocusRipple}
            key={idx}
            label={tab.label}
            disabled={tab.disabled === true}
          />
        ))}
      </Tabs>
    );
  }
);

MuiTabs.displayName = 'MuiTab';
